import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  {
    title: 'Banking',
    icon: { icon: PageMeta.Banking.Icon },
    children: [
      {
        page: PageMeta.Banking.Transactions,
        title: PageMeta.Banking.Transactions.Title,
        icon: { icon: PageMeta.Banking.Transactions.Icon },
        to: PageMeta.Banking.Transactions.Name,
      },
      {
        page: PageMeta.Banking.Accounts,
        title: PageMeta.Banking.Accounts.Title,
        icon: { icon: PageMeta.Banking.Accounts.Icon },
        to: PageMeta.Banking.Accounts.Name,
      },
      {
        page: PageMeta.Banking.Rules,
        title: PageMeta.Banking.Rules.Title,
        icon: { icon: PageMeta.Banking.Rules.Icon },
        to: PageMeta.Banking.Rules.Name,
      },
      {
        page: PageMeta.Banking.TaxCodes,
        title: PageMeta.Banking.TaxCodes.Title,
        icon: { icon: PageMeta.Banking.TaxCodes.Icon },
        to: PageMeta.Banking.TaxCodes.Name,
      },
      {
        page: PageMeta.Banking.Journals,
        title: PageMeta.Banking.Journals.Title,
        icon: { icon: PageMeta.Banking.Journals.Icon },
        to: PageMeta.Banking.Journals.Name,
      },
      {
        page: PageMeta.Banking.Imports,
        title: PageMeta.Banking.Imports.Title,
        icon: { icon: PageMeta.Banking.Imports.Icon },
        to: PageMeta.Banking.Imports.Name,
      },
    ],
  },
]
